import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
/*
=============== 
Variables
===============
*/
:root {
  --primary-light: #E0E0E0;
  /* Primary Color */
  --primary: #0f4062;
  --primary-dark: #828E82;
  --border: 1px solid #828E82;
  --transition: all 0.3s linear;
  --nav-height: 73px;
  --min-footer-height: 73px;
}

/*
=============== 
Global Styles
===============
*/
body {
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.color};
}

a:hover {
  cursor: pointer;
}

.navbar {
  border-bottom: var(--border);
}

.link-icons {
  line-height: 0;
  font-size: 2rem;
  transition: var(--transition);
  color: ${({ theme }) => theme.color};

  &:hover {
        color: var(--primary);
      }
}

.section {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: var(--nav-height) 0;

}

.title {
    font-family: "Arvo";
    font-weight: bold;
}

.card {
  height: 30rem;
  border: var(--border);
  transition: all .2s ease-in-out;
  &:hover {
    transform: scale(1.05);
  }

  .card-img-top {
    height: 50%;
    object-fit: contain;
  }
}

@media screen and (min-width: 800px) {
  .link-icons {
    font-size: 3rem;
  }
  .form-group {
      max-width: 750px;
    }
}

 @media screen and (min-width: 1367px) {
  .link-icons:hover {
    color: var(--primary);
  }
  }
`;

export default GlobalStyles;
